/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function CameraIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="camera"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 17.5C2.5 18.605 3.395 19.5 4.5 19.5L19.5 19.5C20.605 19.5 21.5 18.605 21.5 17.5L21.5 7C21.5 5.895 20.605 5 19.5 5L16.828 5C16.298 5 15.789 4.789 15.414 4.414L14.586 3.586C14.211 3.211 13.702 3 13.172 3L10.828 3C10.298 3 9.789 3.211 9.414 3.586L8.586 4.414C8.211 4.789 7.702 5 7.172 5L4.5 5C3.395 5 2.5 5.895 2.5 7L2.5 17.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={12} r={4} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.5 8L5.5 8" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(133.333)} data-tinysvg-stroke-width="133.333" />
    </svg>
  )
}
